export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.88 19.88">
    <g data-name="Lager 2">
      <g data-name="Lager 1">
        <path d="M19.17 0H.71A.71.71 0 0 0 0 .71v18.46a.71.71 0 0 0 .71.71h18.46a.71.71 0 0 0 .71-.71V.71a.71.71 0 0 0-.71-.71zm-3.93 2.42a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-8.65 0a1 1 0 1 1-1-1 1 1 0 0 1 1 1zm-5.17 16V4.75h17v13.71z" />
        <path d="M6.39 16.06v-5.65c0-.63-.25-.74-.57-.74H4.48V8.62h.15A1.84 1.84 0 0 0 6 8.24a2.32 2.32 0 0 0 .67-1.38h1.14v9.2zM14.73 14v2.11h-1.42V14H9.88v-1.2l3.43-5.89h1.42v5.69h1V14zm-1.42-1.4c0-.21.08-3.66.08-3.66l-2 3.66z" />
      </g>
    </g>
  </svg>
);
